/**
 * Format UTC ISO timestamps in a shift's timezone (IANA identifier).
 * Falls back to local timezone when timezone is missing (e.g. legacy shifts).
 */

/**
 * Format time only (e.g. "9:00 AM") in the given timezone.
 */
export function formatTimeInZone(
  iso: string | null | undefined,
  timezone?: string | null
): string {
  if (!iso) return "--:--";
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "--:--";
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: timezone || undefined,
    });
  } catch {
    return "--:--";
  }
}

/**
 * Format full date (e.g. "Monday, 2 Jan 2026") in the given timezone.
 */
export function formatDateInZone(
  iso: string | null | undefined,
  timezone?: string | null
): string {
  if (!iso) return "";
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: timezone || undefined,
    });
  } catch {
    return "";
  }
}
